import React from "react";
import { FaUserPlus } from "react-icons/fa";
import Loader from "../../../Loader/Loader";
import Modal from "react-modal";
import { IoCloseSharp } from "react-icons/io5";
import { useEvent } from "../../../../context/EventContext";

Modal.setAppElement("#root"); // Set the app root element for accessibility

// * UserDetails is a component that displays the details of a selected user
// * in a modal. The details include the user's name, email, age, and gender.
// * It also displays the connection status of the user with the current user.
// * The connection status can be "Connection Request Accepted", "Connection Request Pending",
// * "No Connection", or "Connection Request Rejected". The component also allows the user
// * to send a connection request to the selected user by clicking on the "Connect" button.
const UserDetails = ({
  modalVisible,
  customStyles,
  handleClose,
  selectedUser,
  connStatus,
  handleConnect,
}) => {
  const { loading } = useEvent();

  return (
    <Modal
      isOpen={modalVisible}
      overlayClassName="overlay"
      style={customStyles}
      contentLabel="Create Event Modal"
    >
      <div className="modal">
        <div className="modal-head">
          <IoCloseSharp onClick={() => handleClose()} className="close-icon" />
        </div>
        <div className="modal-body">
          {selectedUser && (
            <div>
              <h3>User Details</h3>
              <img
                src={selectedUser.userID.profilePicture}
                alt="profile-img"
                style={{ height: "50px", width: "50px" }}
              />
              <p>
                <strong>Name:</strong> {selectedUser.label}
              </p>
              <p>
                <strong>Email:</strong> {selectedUser.userID.email}
              </p>
              <p>
                <strong>Age:</strong> {selectedUser.userID.age}
              </p>
              <p>
                <strong>Gender:</strong> {selectedUser.userID.gender}
              </p>
              <div className="user-buttons">
                {connStatus ? (
                  <span>
                    {connStatus === "Connection Request Accepted" ? (
                      <span
                        style={{
                          color: "green",
                          fontWeight: "bold",
                          fontSize: "20px",
                        }}
                      >
                        Connection Accepted
                      </span>
                    ) : connStatus === "Connection Request Pending" ? (
                      <span
                        style={{
                          color: "blue",
                          fontWeight: "bold",
                          fontSize: "20px",
                        }}
                      >
                        Request Pending
                      </span>
                    ) : connStatus === "No Connection" ? (
                      <button
                        className="add-space"
                        onClick={(e) => handleConnect(e)}
                      >
                        {loading ? (
                          <Loader />
                        ) : (
                          <>
                            <FaUserPlus /> Connect
                          </>
                        )}
                      </button>
                    ) : null}
                  </span>
                ) : (
                  <button
                    className="add-space"
                    onClick={(e) => handleConnect(e)}
                  >
                    {loading ? (
                      <Loader />
                    ) : (
                      <>
                        <FaUserPlus /> Connect
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default UserDetails;
